import React, { useState, useRef } from 'react';
import {
  Keyboard, ScrollView, Text, TouchableOpacity, View,
} from 'react-native';
import { TextInput } from 'react-native-gesture-handler';
import { Avatar, Card } from 'react-native-paper';
import { Feather } from '@expo/vector-icons';
import { AppHeader } from '../../../components/common';
import { pixelDimensions } from '../../../config/utils';
import styles from './styles';

const dataMessages = [
  { type: 'leths', message: 'Olá, meu nome é Patricia, em que posso lhe ajudar?' },
  { type: '', message: 'Olá' },
  { type: '', message: 'Gostaria de mais informações sobre os planos' },
  { type: 'leths', message: 'Claro!' },
  { type: 'leths', message: 'Estou lhe enviando por e-mail a descrição detalhada dos nossos planos.' },
];

const BoxMessage = ({ type, message }) => (
  <View style={type === 'leths' ? styles.viewMessageLeths : styles.viewMessageUser}>
    {type === 'leths' ? (
      <Avatar.Image source={require('../../../assets/icons/company_avatar.png')} size={pixelDimensions(10)} />
    ) : (
      <Avatar.Image source={require('../../../assets/icons/user.png')} size={pixelDimensions(10)} />
    )}
    <Card style={styles.cardBoxMessage}>
      <Text style={styles.nameUserLeths}>{type === 'leths' ? 'Suporte Leths' : 'Nome da Empresa'}</Text>
      <Text style={styles.textBoxMessage}>{message}</Text>
    </Card>
  </View>
);

export default function Chat({ navigation }) {
  const [thisMessage, setThisMessage] = useState('');
  const [listMessages, setListMessages] = useState([...dataMessages]);
  const scrollRef = useRef();

  const sendMessage = () => {
    dataMessages.push({ type: '', message: thisMessage });
    setListMessages(dataMessages);
    setThisMessage();
    Keyboard.dismiss();
    scrollRef.current.scrollToEnd();
  };

  return (
    <>
      <AppHeader navigation={navigation} hasBack title="Chat" />
      <ScrollView
        ref={scrollRef}
        style={styles.baseScroll}
        contentOffset={{ x: 0, y: 0 }}
        keyboardDismissMode="on-drag"
      >
        {listMessages.map((message, index) => <BoxMessage key={index} type={message.type} message={message.message} />)}
      </ScrollView>
      <View style={styles.boxSendMessage}>
        <TextInput
          multiline
          style={styles.inputSendMessage}
          placeholder="Escreva sua Mensagem..."
          value={thisMessage}
          onChangeText={(text) => setThisMessage(text)}
        />
        <TouchableOpacity
          style={styles.buttonSend}
          onPress={() => {
            sendMessage();
          }}
        >
          <Feather name="send" size={pixelDimensions(7)} color="#fff" />
        </TouchableOpacity>
      </View>
    </>
  );
}
